import { z } from "zod";

export const membershipCardSchema = z.object({
  uid: z.string(),
  eventId: z.string(),
  isEventAdmin: z.boolean().optional(),
  eventTitle: z.string().optional(),
  eventStartDate: z.string().optional(),
  eventEndDate: z.string().optional(),
  eventLocation: z.string().nullable().optional(),
  eventDescription: z.string().nullable().optional(),
  // event_card.py writes these as null when the event has no image or slug,
  // and a membership that fails to parse is dropped from the dashboard — so
  // .optional() alone silently hides every event without a hero image.
  eventImage: z.string().nullable().optional(),
  eventSlug: z.string().nullable().optional(),
  // Archiving (TNG-171). Cards written before it lack both, and an absent
  // `eventArchived` means false. A value of the wrong type reads as absent
  // rather than dropping the whole card from the dashboard.
  eventArchived: z.boolean().optional().catch(undefined),
  // The event's IANA zone, which decides when the event is over. Absent on old
  // cards; readers fall back to their own zone then.
  eventTimezone: z.string().nullable().optional().catch(undefined),
  joinedAt: z.any().optional(),
});

export type MembershipCard = z.infer<typeof membershipCardSchema>;
